import { useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { PublicLayout } from "@/components/layout/PublicLayout";
import { GlassCard } from "@/components/GlassCard";
import SEO from "@/components/SEO";
import api from "@/lib/api";
import { container, goldBtn, inputCls, labelCls } from "@/lib/constants";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/password-reset/confirm", { token, new_password: pw });
      toast.success("Password updated. Please sign in.");
      navigate("/auth");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Reset failed.");
    } finally { setBusy(false); }
  };
  return (
    <PublicLayout>
      <SEO title="Reset password" noindex />
      <section className={`${container} py-28`}>
        <GlassCard className="max-w-md mx-auto p-8">
          <h1 className="pdg-serif text-3xl text-foreground">Set a new password</h1>
          {!token ? (
            <p className="mt-4 text-sm text-muted-foreground">This reset link is missing a token. Request a new one from the sign-in page.</p>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-5">
              <div>
                <label className={labelCls}>New password</label>
                <input type="password" required minLength={8} className={inputCls} value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password-input" />
              </div>
              <button disabled={busy} className={goldBtn} data-testid="reset-password-submit">{busy ? "Updating…" : "Update password"}</button>
            </form>
          )}
          <Link to="/auth" className="mt-6 inline-block text-sm text-[hsl(var(--pdg-gold))]">Back to sign in</Link>
        </GlassCard>
      </section>
    </PublicLayout>
  );
}
